import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = _Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { getENV } from '../utils';
import Sdk from './sdk';
import { mobileBridge, mobileBridgeInit, PcBridgeInit, pcBridge } from './bridge';
import Event from './helper/event';
var env = getENV();
var platform = env.platform;
var yachSdk = new Sdk(env);
function initSdk() {
  var _this = this;
  var bridgeInit;
  if (platform === 'pc') {
    bridgeInit = function bridgeInit() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              PcBridgeInit();
              return _context.abrupt("return", pcBridge);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    };
  } else {
    bridgeInit = function bridgeInit() {
      return mobileBridgeInit().then(function () {
        return mobileBridge;
      });
    };
  }
  var config = {
    platform: platform,
    authMethod: 'config',
    bridgeInit: bridgeInit,
    event: {
      on: function on(event, fn) {
        Event.on(event, fn);
      },
      off: function off(event, fn) {
        Event.off(event, fn);
      }
    }
  };
  yachSdk.setPlatform(config);
}
initSdk();
export { yachSdk, initSdk };


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/lib/index.js
// module id = null
// module chunks = 